import {
  RussiaBanner,
  CrimeaBanner,
} from '@skyscanner-internal/global-components/legal-banner';
import { logError, logOperationalEvent, logWarn } from 'saddlebag-logger';

import { withI18n } from '../../../contexts/i18n';

import { shouldShowCrimeaBanner } from './crimea-restrictions';
import { shouldShowRussiaBanner } from './russia-restrictions';

import type { Configs } from '@shared/types/configs';
import type { I18nService } from '@shared/types/i18n';
import type { EntityId, Optional } from '@shared/types/utils';

import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';

type Props = {
  i18n: I18nService;
  entityId: Optional<EntityId>;
  nationId: Optional<EntityId>;
  configs: Configs;
  isProductionEnv: boolean;
};

const LegalBanner = ({
  configs: { ukraineBannerEnabled },
  entityId,
  i18n: { culture, translate },
  isProductionEnv,
  nationId,
}: Props) => {
  if (entityId && shouldShowCrimeaBanner(culture.market, entityId)) {
    return (
      <CrimeaBanner
        strings={{
          bannerText: translate('ktxt_crimea_messaging'),
          dismissText: translate('banner_ok_btn'),
        }}
        logger={{ logOperationalEvent, logError, logWarn }}
        isProductionEnv={isProductionEnv}
      />
    );
  }

  if (nationId && ukraineBannerEnabled && shouldShowRussiaBanner(nationId)) {
    return (
      <RussiaBanner
        strings={{
          bannerText: translate('new_messaging_russian'),
          dismissText: translate('banner_ok_btn'),
        }}
        logger={{ logOperationalEvent, logError, logWarn }}
        isProductionEnv={isProductionEnv}
      />
    );
  }

  return null;
};

export default withConfiguration(withI18n(LegalBanner));
